// extracted by mini-css-extract-plugin
module.exports = {"bag":"style_bag__Ecyj_","bag-count":"style_bag-count__oCWBH","bag-count-number":"style_bag-count-number__c3uGW","bag-icon":"style_bag-icon__FU9kR"};